<template>
    <div class="container-fluid">
        <Breadcrumb title="Add PMTA Email Test" v-bind:button-show="false"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <PmtaEmailTestForm @hidePreloader="hidePreloader"></PmtaEmailTestForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import PmtaEmailTestForm from './forms/PmtaEmailTestForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'PmtaEmailTest',
        components: {
            Preloader,PmtaEmailTestForm, Breadcrumb
        },
        data() {
            return {
                loading: false
            }
        },
        mounted() {
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            }
        }
    }
</script>

<style scoped>

</style>
